const mapSentimentTypeToColor = (sentimentName: string | undefined) => {
  switch (sentimentName) {
    case 'Positive':
      return {
        color: 'sentiment.positive',
      };

    case 'Negative':
      return {
        color: 'sentiment.negative',
      };

    case 'Neutral':
      return {
        color: 'sentiment.neutral',
      };

    default:
      return {
        color: 'sentiment.neutral',
      };
  }
};

export default mapSentimentTypeToColor;
